<template>
    <ContainerWithMenu>
        <div class="page-content">
            New Reservation
        </div>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";

    export default {
        name: "Booking",
        components: { ContainerWithMenu }
    };
</script>
